
      import LoginPage from '../cross-app-frontend/LoginPage.vue';
      import { createApp } from 'vue';
      import { createRouter, createWebHistory } from 'vue-router';

      const router = createRouter({
        history: createWebHistory(),
        routes: [
          {
            path: '/login',
            name: 'Login',
            component: () => import('../cross-app-frontend/LoginPage.vue'),
          },
        ],
      });
      const app = createApp(LoginPage);
      app.config.throwUnhandledErrorInProduction = true;
      app.use(router);
      app.mount('#app');
    